import { c as _c } from "react/compiler-runtime";
import { FormInput, PaymentProcessorEnum, PrimaryButton, getPaymentProcessorTitle, useTranslation as useUiTranslation } from '@systemeio/ui';
import HelpCenterLink from 'modules/profile/payment-gateways/components/help-center-link';
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations';
import { razorpayConnect } from 'modules/profile/payment-gateways/integrations/razorpay/api';
import { PaymentRazorpayInterface } from 'modules/profile/payment-gateways/integrations/razorpay/types';
import { getRazorpayHelpPageLink } from 'modules/profile/payment-gateways/integrations/razorpay/utils';
import React, { useState } from 'react';
import CreateModal from 'shared/components/create-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { fetchWithErrors } from 'shared/utils/fetch-with-errors';
const defaultValues: PaymentRazorpayInterface = {
  apiKeyId: '',
  apiKeySecret: ''
};
const defaultErrors: PaymentRazorpayInterface = {
  apiKeyId: '',
  apiKeySecret: ''
};
const RazorpayCreateModal = () => {
  const $ = _c(37);
  const {
    t
  } = useLocoTranslation();
  const {
    t: tUi
  } = useUiTranslation();
  const {
    user
  } = useUser();
  const [opened, setOpened] = useState(false);
  const [errors, setErrors] = useState(defaultErrors);
  const {
    mutatePaymentIntegrations
  } = useConnectedPaymentIntegrations();
  let t0;
  if ($[0] !== mutatePaymentIntegrations) {
    t0 = async data => {
      await fetchWithErrors(async () => {
        await razorpayConnect(data);
        await mutatePaymentIntegrations();
      }, setErrors);
    };
    $[0] = mutatePaymentIntegrations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onCreate = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = e => {
      e.preventDefault();
      setOpened(true);
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("dashboard.settings.payment_gateways.connect");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <PrimaryButton onClick={t1} className="font-bold">{t2}</PrimaryButton>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t || $[8] !== tUi) {
    t4 = t("dashboard.settings.payment_gateways.connect_payment_title", {
      payment: getPaymentProcessorTitle(PaymentProcessorEnum.Razorpay, tUi)
    });
    $[7] = t;
    $[8] = tUi;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setOpened(false);
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== errors || $[12] !== t) {
    t6 = {
      field: "apiKeyId",
      onRender: (value, onChange) => <FormInput key="razorpay-apiKeyId-create" label={t("dashboard.settings.payment-gateways.api_key_id")} value={value} onChange={e_0 => onChange(e_0.target.value)} error={errors.apiKeyId} />
    };
    $[11] = errors;
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== errors || $[15] !== t) {
    t7 = {
      field: "apiKeySecret",
      onRender: (value_0, onChange_0) => <FormInput key="razorpay-apiKeySecret-create" label={t("dashboard.settings.payment-gateways.api_secret_key")} value={value_0} onChange={e_1 => onChange_0(e_1.target.value)} error={errors.apiKeySecret} />
    };
    $[14] = errors;
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7) {
    t8 = [t6, t7];
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const t9 = user?.dashboardLocale;
  let t10;
  if ($[20] !== t9) {
    t10 = getRazorpayHelpPageLink(t9);
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== tUi) {
    t11 = getPaymentProcessorTitle(PaymentProcessorEnum.Razorpay, tUi);
    $[22] = tUi;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11) {
    t12 = <HelpCenterLink link={t10} integration={t11} />;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = ["apiKeyId", "apiKeySecret"];
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== onCreate || $[29] !== opened || $[30] !== t12 || $[31] !== t4 || $[32] !== t8) {
    t14 = <CreateModal fullCaption={t4} opened={opened} onClose={t5} defaultValues={defaultValues} needToast={false} creatable={t8} additionalInfo={t12} onCreate={onCreate} requiredFields={t13} />;
    $[28] = onCreate;
    $[29] = opened;
    $[30] = t12;
    $[31] = t4;
    $[32] = t8;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t14 || $[35] !== t3) {
    t15 = <>{t3}{t14}</>;
    $[34] = t14;
    $[35] = t3;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  return t15;
};
export default RazorpayCreateModal;